export type ReportView =
  | "landing"
  | "siteMeeting"
  | "annualSummary"
  | "searchPrintouts"
  | "reportFiles"
  | "invoiceReport"
  | "invoicingReport"
  | "contractDiaryReport"
  | "toContractorReport"
  | "unitPrices"
  | "deductionRelease";

export interface ReportLinkItem {
  id: string;
  href: string;
  translationKey: string;
  defaultLabel: string;
  external?: boolean;
  navigationTarget?: ReportView;
  requiredPermission?: string;
  /** Opt-in: hide when ENABLE_* setting is missing (Stara-style features). */
  defaultEnabled?: boolean;
}

export const reportLinks: ReportLinkItem[] = [
  {
    id: "open-powerbi-summary-report",
    href: "https://app.powerbi.com/view?r=eyJrIjoiZDYwMjc2OGQtNzY0MS00M2JjLWI0MWYtNjMxZDIyMjNjMWUyIiwidCI6ImM4ODIzYzkxLWJlODEtNGY4OS1iMDI0LTZjM2RkNzg5YzEwNiIsImMiOjh9",
    translationKey: "REPORTS_OPEN_POWERBI_SUMMARY",
    defaultLabel: "Open the PowerBI summary report",
    external: true,
  },
  {
    id: "search-printouts",
    href: "#printouts",
    translationKey: "REPORTS_SEARCH_PRINTOUTS",
    defaultLabel: "Search for printouts",
    navigationTarget: "searchPrintouts",
    requiredPermission: "CITY_OBJECT_SHOW",
  },
  {
    id: "files",
    href: "#files",
    translationKey: "REPORTS_FILES",
    defaultLabel: "Files",
    navigationTarget: "reportFiles",
    requiredPermission: "CITY_OBJECT_REPORT_FILES_SHOW",
  },
  {
    id: "site-meeting-report",
    href: "#site-meeting",
    translationKey: "REPORTS_SITE_MEETING",
    defaultLabel: "Site meeting report",
    navigationTarget: "siteMeeting",
    requiredPermission: "CITY_OBJECT_MEETING_REPORT",
  },
  {
    id: "annual-summary",
    href: "#annual-summary",
    translationKey: "REPORTS_ANNUAL_SUMMARY",
    defaultLabel: "Annual summary",
    navigationTarget: "annualSummary",
    requiredPermission: "CITY_OBJECT_YEAR_REPORT",
  },
  {
    id: "deduction-release",
    href: "#deduction-release",
    translationKey: "REPORTS_DEDUCTION_RELEASE",
    defaultLabel: "Deduction release",
    navigationTarget: "deductionRelease",
    requiredPermission: "CITY_OBJECT_DETUCTION_RELEASE_SHOW",
    // Stara opt-in — missing ENABLE_DEDUCTION_RELEASE must hide the link
    defaultEnabled: false,
  },
  {
    id: "invoice-report",
    href: "#invoice-report",
    translationKey: "REPORTS_INVOICE_REPORT",
    defaultLabel: "Search for invoiced objects",
    navigationTarget: "invoiceReport",
    requiredPermission: "CITY_OBJECT_INVOICE_REPORT",
  },
  {
    id: "invoicing-report",
    href: "#invoicing-report",
    translationKey: "REPORTS_INVOICING_REPORT",
    defaultLabel: "Search for invoiceable objects",
    navigationTarget: "invoicingReport",
    requiredPermission: "CITY_OBJECT_INVOICING_REPORT",
  },
  {
    id: "contract-diary-report",
    href: "#contract-diary",
    translationKey: "REPORTS_CONTRACT_DIARY",
    defaultLabel: "Contract diary report",
    navigationTarget: "contractDiaryReport",
    requiredPermission: "CITY_OBJECT_CONTRACT_DIARY_REPORT",
  },
  {
    id: "to-contractor-report",
    href: "#to-contractor",
    translationKey: "REPORTS_TO_CONTRACTOR",
    defaultLabel: "Search for given to contractor objects",
    navigationTarget: "toContractorReport",
    requiredPermission: "CITY_OBJECT_TO_CONTRACTOR_REPORT",
  },
  {
    id: "unit-prices",
    href: "#unit-prices",
    translationKey: "REPORTS_UNIT_PRICES",
    defaultLabel: "Contract unit prices",
    navigationTarget: "unitPrices",
    requiredPermission: "PRICES_SHOW",
  },
];

export const permissionNoteConfig = {
  translationKey: "REPORTS_BASED_ON_PERMISSIONS",
  defaultLabel: "",
};
